import PlanUpgradePopUp from '@/pages/plan-upgrade-popup/PlanUpgradePopUp';
import { useAnalytics } from '@/services/analytics';
import { useAuth } from '@/services/auth';
import { useUserSettings } from '@/state/user-settings/UserSettingsProvider';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { useState } from 'react';
import ExpandableButton from '../Buttons/ExpandableButton';

const OFFER_DAYS = 4;

const DAYS_IN_MILISECONDS = 1000 * 60 * 60 * 24;
const HOURS_IN_MILISECONDS = 1000 * 60 * 60;
const MINUTES_IN_MILISECONDS = 1000 * 60;

const StyledExpandableButton = styled(ExpandableButton)<{ expanded: boolean }>`
    background-color: #493021;
    border-radius: 8px;
    padding: 14px 16px;
    gap: 4px;
    display: flex;
    flex-direction: column;
    padding: ${({ expanded }) => (expanded ? '0.75rem 0' : '8px')};

    :hover {
        background-color: #593b28;
    }
`;

const Title = styled(Typography)`
    display: flex;
    flex-direction: row;
    color: ${({ theme }) => theme.colors.primary.main};
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
`;

const SubTitle = styled(Typography)`
    color: ${({ theme }) => theme.colors.white};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
`;

const StyledCollapsedIcon = styled.div`
    font-size: 30px;
`;

const calculateLeftTime = (popupTime: Date) => {
    const now = Date.now();
    const expirationTime = popupTime.getTime() + DAYS_IN_MILISECONDS * OFFER_DAYS;
    return expirationTime - now;
};

const calculateLeftTimeString = (popupTime: Date) => {
    const leftTime = calculateLeftTime(popupTime);
    const days = Math.floor(leftTime / DAYS_IN_MILISECONDS);
    const hoursLeftTime = leftTime % DAYS_IN_MILISECONDS;
    const hours = Math.floor(hoursLeftTime / HOURS_IN_MILISECONDS);
    const minutesLeftTime = hoursLeftTime % HOURS_IN_MILISECONDS;
    const minutes = Math.floor(minutesLeftTime / MINUTES_IN_MILISECONDS);

    return days + 'd ' + hours + 'hrs ' + minutes + 'm';
};

export const DiscountOfferTimer = ({ isExpanded }: { isExpanded: boolean }) => {
    const [isDiscountModalOpen, setIsDiscountModalOpen] = useState(false);
    const { user } = useAuth();
    const mixpanel = useAnalytics();
    const { userSettings } = useUserSettings();
    const popupTime = userSettings?.messages?.monthlyToAnnualDiscountOffer?.time;
    const isShowTime = popupTime ? calculateLeftTime(new Date(popupTime)) > 0 : false;
    const monthlyUser = user?.billingInterval === 'month';

    const onClick = () => {
        mixpanel?.track('promotion', { event: 'click' });
        setIsDiscountModalOpen(true);
    };

    return (
        <>
            {isShowTime && monthlyUser && (
                <StyledExpandableButton
                    ariaLabel="discount timer"
                    expanded={isExpanded}
                    icon={''}
                    isImage
                    isOpen={isExpanded}
                    iconStyleOverride={_ => ({
                        display: 'none',
                    })}
                    collapsedContent={<StyledCollapsedIcon>🎁</StyledCollapsedIcon>}
                    onClick={onClick}>
                    <Title>🎁 Annual Plan offer</Title>
                    <SubTitle>Expires in {calculateLeftTimeString(popupTime ? new Date(popupTime) : new Date())}</SubTitle>
                </StyledExpandableButton>
            )}
            <PlanUpgradePopUp show={isDiscountModalOpen} setIsOpen={setIsDiscountModalOpen} />
        </>
    );
};
